import { GET_CEs } from "../../Actions/ActionConstants";

function CEsReducer(state=null,action){
    switch (action.type) {
        case GET_CEs:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default CEsReducer